import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface LocationState {
  path: string;
}

const initialState = {
  path: "/",
} as LocationState;

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    rememberLocation: (state, action: PayloadAction<string>) => {
      state.path = action.payload;
    },
    forgetLocation: (state) => {
      state.path = "/";
    },
  },
});

export const { rememberLocation, forgetLocation } = locationSlice.actions;

export default locationSlice.reducer;
